import React from 'react'

import { GreenArrowEl } from './style'

const GreenArrow = ({ number }) => {
  return <GreenArrowEl>{number}</GreenArrowEl>
}

export default GreenArrow
